// Shared navigation eligibility. The API rechecks the current database user on every request.
const normalized = value => String(value || '').trim().toUpperCase().replace(/[ _-]+/g, ' ');
const CRM_DEPARTMENTS = ['SEO', 'PROJECT OPERATIONS', 'UPWORKS', 'UPWORK'];
function canAccessCRM(user) {
    return ['ADMIN', 'MANAGER', 'TEAM LEAD'].includes(normalized(user?.role)) || CRM_DEPARTMENTS.includes(normalized(user?.department));
}
function crmCapabilities(user) {
    const admin = normalized(user?.role) === 'ADMIN';
    return { admin, manageAssignments: admin, viewAllVendors: admin || normalized(user?.role) === 'MANAGER', clients: admin, financials: admin, configuration: admin };
}
module.exports = { canAccessCRM, crmCapabilities, CRM_DEPARTMENTS };
